export default __webpack_public_path__ + "static/media/thumbnail-10.ebd4c406.jpg";